import Newsletter from './Newsletter';

const View = (props: any) => {
  return <Newsletter data={props.data} />;
};

export default View;
